
import comLeaveWord from '@/components/com-leave-word.vue';
import comRichtext from '@/components/com-richtext.vue';
export default {
	name: 'CommunicationDetail',
	data () {
		return {
			chatId: '', // 内容id
			source: 'JLZX', // 留言类型
			
			detail: {},

			page:{
              targetPage:1,
              pageSize:10,
              totalPage:0,
              type:2,
            },

            argusList: [], // 评论列表
		}
	},
	components:{
		comLeaveWord,
		comRichtext,
    },
	mounted () {
		this.chatId = this.$route.query.id;
		
		this.getDetail();
	},
	methods: {
		getDetail () {
			var param = {
				id: this.chatId
			}

			this.get(this.api.getJLZXDetail, param).then(res => {
				if (res.result == 200) {
					this.detail = res.data;
				}
			})
		},
	}
}


